import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone } from '../utils'
import Loading from './Loading'
import { useDispatch, useSelector } from 'react-redux'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '../firebase'
import { redNex } from '../Redux/nexSlice'

function LinkAnalysis({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)

          const updateAnalytics = async ()=> {
            const tool = window.location.pathname.split('/').pop()
            let tools = deepClone(user.analytics.toolsUsage)
    
            tools[tool]+= 1
            await updateDoc(doc(db, 'users', user.id), {analytics: {toolsUsage:tools}})
          }

            setIsLoading(true)
              fetch(`${base}/res`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'la',
                  url: url,
                  userId: user.id
                })
              }).then(res=> res.json()).then(data=> {
                setData([data])
                setIsLoading(false)
                dispatch(redNex(nx))
                updateAnalytics()
              })
            } else {
              if(url.trim() === '') setNoInput1(true)
            }
    }



  return (
    <LinkAnalysisContainer>
            <LinkAnalysisInputContainer>
            <h2>Link Analysis <span style={{fontSize: 'medium'}}></span></h2>
            <LinkAnalysisInnerInputContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </LinkAnalysisInnerInputContainer>
        </LinkAnalysisInputContainer>

        {data.length !== 0 && !isLoading && <LinkAnalysisResContainer>
           <LinkAnalysisRes style={{border: 'none'}}>
                <div>
                    <h3>{data[0]?.totalLinks}</h3>
                    <p>Total links</p>
                </div>
                <div>
                    <h3>{data[0]?.external}</h3>
                    <p>External links</p>
                </div>
                <div>
                    <h3>{data[0]?.internal}</h3>
                    <p>Internal links</p>
                </div>
                <div>
                    <h3>{data[0]?.nofollowLinks}</h3>
                    <p>Nofollow links</p>
                </div>
           </LinkAnalysisRes>

            {data[0].analysis.length !== 0 && <>
           <LinkAnalysisRes style={{fontWeight: '400', marginTop: '30px'}}>
                    <p style={{width: '500px'}}>Link</p>
                    <p style={{width: '300px', marginInline: '20px'}}>Anchor Text</p>
                    <p style={{width: '100px'}}>Type</p>
                    <p style={{width: '50px', marginLeft: 'auto', marginRight: '30px'}}>Dofollow?</p>
            </LinkAnalysisRes>

            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
           {data[0].analysis.map(l=> {
            return (
                <LinkAnalysisRes>
                    <p style={{width: '500px'}}>{l.link}</p>
                    <p style={{width: '300px', marginInline: '20px'}}>{l.anchorText}</p>
                    <p style={{width: '100px'}}>{l.type}</p>
                    <p style={{width: '50px', marginLeft: 'auto'}}>{l.follow}</p>
                </LinkAnalysisRes>
            )
           })}
           </div></>}
        </LinkAnalysisResContainer>}
        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Link Analysis Tool provides a summary of the backlinks pointing to your website. 
            It helps you understand the quantity and quality of backlinks, which are crucial for improving your site's authority and search engine rankings.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of the page you want to analyze</p>
          <p>2. Click "Get Data" to get a summary of the backlinks</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Focus on acquiring high-quality backlinks from authoritative sites to enhance your site's credibility and rankings</p>

        </Intro>}
    </LinkAnalysisContainer>
  )
}

export default LinkAnalysis


const LinkAnalysisContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const LinkAnalysisInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--cntnt-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--cntnt-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--cntnt-color);
    color: white;
  }

  > div > button:hover {
    color: var(--cntnt-color);
    background-color: rgb(239, 239, 239);
  }
`


const LinkAnalysisInnerInputContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--cntnt-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`

const LinkAnalysisResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const LinkAnalysisRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);


    > div {
        display: flex;
        flex-direction: column;
        width: 700px;
        margin-left: 30px;
        margin-right: 20px;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    > div > h3 {
        font-weight: 300;
    }
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`